import axios from 'axios';

// Formats axios errors into user-friendly messages
const handleFetchError = (err, defaultMessage, setErrorFn) => {
  let errorMessage = defaultMessage;

  if (err.response) {
    if (err.response.status === 401 || err.response.status === 403) {
      errorMessage = 'Authentication error. Please log in again.';
    } else {
      errorMessage += `: ${err.response.data?.message || err.response.statusText || err.message}`;
    }
  } else if (err.request) {
    errorMessage += ': No response from server. Please check your connection.';
  } else {
    errorMessage += `: ${err.message}`;
  }

  setErrorFn(errorMessage);
};

// Authenticated axios request supporting GET, POST, DELETE via method option
const makeAuthenticatedRequest = async (url, token, { method = 'get', data } = {}) => {
  if (!token) {
    throw new Error('No authentication token available');
  }
  return await axios({
    method,
    url,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    ...(data !== undefined && { data })
  });
};

export { handleFetchError, makeAuthenticatedRequest };
